import { ListOrdersInProductParameters } from './types';

export const listOrdersInProductParameters: ListOrdersInProductParameters = ({ user, productId }) => {
    return {
        companyIds: user?.company?.id ? [user?.company?.id] : [],
        userId: user?.id || 0,
        productId,
    };
};
